<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Advisory Board</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/advisoryboard" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateAdvisoryBoard" v-if="advisoryBoard">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">

                      <div class="col-md-12">
                        <fg-input type="text"
                                      v-model="advisoryBoard.key"
                                      label="Enter Member Name"
                                      placeholder="Member Name"
                                      data-vv-name="key"
                                      cus-name="key"
                        >
                        </fg-input>
                      </div>

                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="advisoryBoard.value"
                                  label="Member Position or Role"
                                  placeholder="Member Position or Role"
                                  data-vv-name="value"
                                  cus-name="value"
                        >
                        </fg-input>
                      </div>

                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="advisoryBoard.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Advisory Board
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditAdvisoryBoard',
        created (){
          this.$store.dispatch('GET_SELECTED_ADVISORYBOARD', this.$route.params.advisoryBoardId).then(() =>{
            this.advisoryBoard = this.selectedAdvisoryBoard;
          })
    },
    data () {
        return {
          advisoryBoard: this.selectedAdvisoryBoard || {},
          rules: {
            active: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
      updateAdvisoryBoard () {
        this.$validator.validateAll().then((result) => {
            if (result) {
              let updateAdvisoryBoard = () =>{
                this.$store.dispatch('UPDATE_ADVISORY_BOARD', this.advisoryBoard)
                  .then((res) => {
                    console.log("UPDATE_ADVISORY_BOARD res : ", res);
                    this.showPopup('Success!', 'Advisory Board is successfully updated', 'success', ()=>this.$router.push('/admin/advisoryboard'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_ADVISORY_BOARD API error : ", err);
                  })
              };
              updateAdvisoryBoard();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'selectedAdvisoryBoard']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Podcast/EditAdvisoryBoard.vue